module.exports = __webpack_public_path__ + "static/img/dng.bad1cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/dng.png
// module id = UfG7
// module chunks = 53